import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalCacheService } from '../core/local-cache.service';
import { AccountGroup } from './../account-group/account-group';
import { AccountGroupService } from './../account-group/account-group.service';

@Injectable({ providedIn: 'root' })
export class AccountGroupCacheService extends LocalCacheService<AccountGroup> {
  constructor(private accountGroupService: AccountGroupService) {
    super();
  }

  protected load(ids: Array<string>): Observable<{ [key: string]: AccountGroup }> {
    return this.accountGroupService.getAccountGroups(ids).pipe(
      map((accountGroups) =>
        accountGroups.reduce((agMap, accountGroup) => {
          agMap[accountGroup.accountGroupId] = accountGroup;
          return agMap;
        }, {}),
      ),
    );
  }

  deleteFromCacheForAccountGroup(accountGroupId: string): void {
    localStorage.removeItem(`${this.namespace()}|${accountGroupId}`);
  }

  protected maxAge(): number {
    return 24 * 3600 * 1000;
  }

  protected namespace(): string {
    return 'multi-location-account-group';
  }
}
